import { normalize } from 'normalizr';

export default function makeDataNormalizer(schema) {
  return (data) => normalize(data, Array.isArray(data) ? [schema] : schema);
}
